import React from "react";
import DashboardShell from "../../dashboard/DashboardShell";
import Seo from "../../components/Seo";

const NAV = [
  { to: "/dashboard", label: "Home", end: true, icon: "home" },
  { to: "/dashboard/projects", label: "Projects", icon: "projects" },
  { to: "/dashboard/messages", label: "Messages", icon: "messages" },
  { to: "/dashboard/team", label: "Team", icon: "users" },
  { to: "/dashboard/invoices", label: "Invoices", icon: "invoices" },
];

const ClientLayout = () => (
  <>
    {/* See AdminLayout — auth-gated, and explicitly out of the index. */}
    <Seo title="Dashboard — bboy creative" path="/dashboard" noindex />
    <DashboardShell navItems={NAV} roleLabel="Client" />
  </>
);

export default ClientLayout;
